// extracted by mini-css-extract-plugin
export var externalLink = "_7l-0";
export var internalLinkLabel = "_7l-1";